import type { CarouselFavoriteType } from '@/types';
import { useLingui } from '@lingui/react';
import { AspectRatio, Group, Image, NumberFormatter, Stack, Text, useMatches } from '@mantine/core';
import { PlayNowButton } from './PlayNowButton';
export const FavoriteCard: React.FC<CarouselFavoriteType> = ({
  id,
  imgCard,
  time,
  wagered,
  profit
}) => {
  const {
    i18n
  } = useLingui();
  const ratio = useMatches({
    base: 128 / 136,
    lg: 148 / 157
  });
  return <Stack gap={4} pr={{
    base: 0,
    sm: 8
  }} style={{
    cursor: 'pointer'
  }}>
      <AspectRatio ratio={ratio}>
        <Image src={imgCard} alt={`favorite-card-${id}`} />
      </AspectRatio>

      <Group justify="space-between" mt={8} wrap="nowrap">
        <Text tt="uppercase" fw={700} fz={{
        base: 10,
        sm: 12
      }} c="var(--text-dark)">
          {i18n._('Times played')}
        </Text>
        <Text fw={500} fz="xs" c="var(--text-dark)">
          {time}
        </Text>
      </Group>

      <Group justify="space-between" wrap="nowrap">
        <Text tt="uppercase" fw={700} fz={{
        base: 10,
        sm: 12
      }} c="var(--text-dark)">
          {i18n._('Wagered')}
        </Text>
        <Text fw={500} fz="xs" c="var(--text-dark)">
          <NumberFormatter value={wagered} thousandSeparator="," prefix="$" />
        </Text>
      </Group>

      <Group justify="space-between" mb={8} wrap="nowrap">
        <Text tt="uppercase" fw={700} fz={{
        base: 10,
        sm: 12
      }} c="var(--text-dark)">
          {i18n._('Profit')}
        </Text>
        <Text fw={700} fz="xs" c="var(--text-green)">
          <NumberFormatter value={profit} thousandSeparator="," prefix="$" />
        </Text>
      </Group>

      <PlayNowButton />
    </Stack>;
};